/**
 * Public URL allow-list.
 * Vercel serves a file when one exists, then these rewrites, then 404.
 * A path that is not a file and not in SPA_REWRITES must not be rewritten to index.html.
 */

export const SITE_ORIGIN = 'https://www.farzadbayat.com'

export const SPA_REWRITES = ['/landing', '/chat', '/admin', '/future-chat'] as const

/** Paths that must exist as static files after `pnpm build`. */
export const STATIC_HTML: Record<string, string> = {
  '/': 'index.html',
  '/ai-agency': 'ai-agency/index.html',
  '/about': 'about/index.html',
  '/fixer': 'fixer/index.html',
  '/privacy': 'privacy/index.html',
  '/terms': 'terms/index.html',
  '/workshops': 'workshops/index.html',
  '/blog/': 'blog/index.html',
  '/blog/ai-signal-20260609/': 'blog/ai-signal-20260609/index.html',
  '/reports/sample-discovery-report.html': 'reports/sample-discovery-report.html',
}

export const SITEMAP_PATHS = [
  '/',
  '/workshops',
  '/ai-agency',
  '/about',
  '/blog/',
  '/blog/ai-signal-20260609/',
] as const

export const NOINDEX_PATHS = [
  '/fixer',
  '/reports/sample-discovery-report.html',
  '/landing',
  '/chat',
  '/admin',
] as const

export type PublicView =
  | 'landing'
  | 'chat'
  | 'admin'
  | 'about'
  | 'privacy'
  | 'terms'
  | 'ai-agency'
  | 'fixer'
  | 'workshops'
  | 'not-found'

const VIEW_BY_PATH: Record<string, PublicView> = {
  '/': 'landing',
  '/landing': 'landing',
  '/admin': 'admin',
  '/about': 'about',
  '/chat': 'chat',
  '/privacy': 'privacy',
  '/terms': 'terms',
  '/ai-agency': 'ai-agency',
  '/fixer': 'fixer',
  '/workshops': 'workshops',
  '/future-chat': 'chat',
}

export function normalizePath(pathname: string): string {
  if (pathname.length > 1 && pathname.endsWith('/')) return pathname.replace(/\/+$/, '') || '/'
  return pathname || '/'
}

export function viewForPath(pathname: string): PublicView {
  const path = normalizePath(pathname)
  return VIEW_BY_PATH[path] ?? 'not-found'
}
